"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateDeliveryError = exports.OutOfHoursOrderError = exports.DeliveryServiceUnavailableError = exports.PaymentExceededDenied = exports.SalesOrderPaymentError = exports.CompleteSalesOrderError = void 0;
/**
 * Error used when the sales order could not be completed in the ERP system
 */
class CompleteSalesOrderError extends Error {
    constructor(m) {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, CompleteSalesOrderError.prototype);
    }
}
exports.CompleteSalesOrderError = CompleteSalesOrderError;
class SalesOrderPaymentError extends Error {
    constructor(m) {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, SalesOrderPaymentError.prototype);
    }
}
exports.SalesOrderPaymentError = SalesOrderPaymentError;
class PaymentExceededDenied extends Error {
    constructor(m) {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, PaymentExceededDenied.prototype);
    }
}
exports.PaymentExceededDenied = PaymentExceededDenied;
class DeliveryServiceUnavailableError extends Error {
    constructor(m) {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, DeliveryServiceUnavailableError.prototype);
    }
}
exports.DeliveryServiceUnavailableError = DeliveryServiceUnavailableError;
class OutOfHoursOrderError extends Error {
    constructor(m) {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, OutOfHoursOrderError.prototype);
    }
}
exports.OutOfHoursOrderError = OutOfHoursOrderError;
class DuplicateDeliveryError extends Error {
    constructor(m) {
        super(m);
        // set the prototype explicitly.
        Object.setPrototypeOf(this, DuplicateDeliveryError.prototype);
    }
}
exports.DuplicateDeliveryError = DuplicateDeliveryError;
//# sourceMappingURL=errorTypes.js.map